"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Search/Refined/SearchHitInThread.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _icons = require('./icons');
var _searchHitHighlight = require('./searchHitHighlight');
var _searchSession = require('./searchSession');







const reopenSearch = () => _searchSession.searchSession.reopen()

/**
 * When this chat was opened at a message from search, marks the searched words in that
 * message and, if it came from the search window, offers "Back to results".
 */
const SearchHitInThread = ({ conversationKey, messageKey }) => {
  const hit = _searchSession.useSearchHit.call(void 0, )
  const isHere = !!hit && hit.conversationKey === conversationKey
    && !!messageKey && hit.messageKey === messageKey

  _searchHitHighlight.useSearchHitHighlight.call(void 0, isHere ? hit.messageKey : null, isHere ? hit.query : null)

  if (!isHere || !hit.fromWindow) return null
  return (
    _react2.default.createElement('button', { type: "button", className: "search-back-to-results", onClick: reopenSearch, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , _react2.default.createElement(_icons.ChevronLeftIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
      , `Back to results for \u201C${hit.query}\u201D`
    )
  )
}

exports. default = _react.memo.call(void 0, SearchHitInThread)
